module.exports = __webpack_public_path__ + "img/ic_24_team_ernaehrung.69f5986e.svg";